import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader, DataTable, Section, Loading } from "../components/Common";

export default function Medical() {
  const [items, setItems] = useState(null);
  const [students, setStudents] = useState([]);
  useEffect(() => {
    api.medicalRecords().then(({ data }) => setItems(data)).catch(() => setItems([]));
    api.students().then(({ data }) => setStudents(data));
  }, []);
  const stuMap = Object.fromEntries(students.map((s) => [s.id, s]));
  if (items === null) return <Loading />;
  return (
    <div data-testid="medical-page">
      <PageHeader kicker="School Health" title="Medical Records" subtitle="Confidential health visit log." />
      <Section>
        <DataTable
          columns={[
            { key: "date", label: "Date" },
            { key: "student", label: "Student", render: (r) => {
              const s = stuMap[r.student_id];
              return s ? `${s.first_name} ${s.last_name}` : "—";
            } },
            { key: "type", label: "Type" },
            { key: "description", label: "Description" },
            { key: "treatment", label: "Treatment" },
          ]}
          rows={items}
        />
      </Section>
    </div>
  );
}
